import React, { useState } from 'react';
import { Timeline } from 'react-event-timeline';
import Text from '@amzn/meridian/text';
import Checkbox from '@amzn/meridian/checkbox';
import Row from '@amzn/meridian/row';
import Column from '@amzn/meridian/column';
import { useIntl } from 'react-intl';
import { FormattedMessage } from 'react-intl';

import {
  ContactData,
  ContactTimelineEvent,
  EventType,
} from '../../../api/ContactListening/schema';
import ContactTimelineEventBox from './ContactTimelineEventBox';
import { MERIDIAN_COLORS } from '../../../Util';
import CoachingEmptyState from '../../../Assets/coachingEmptyState.png';

export interface ContactTimelineDisplayProps {
  loadingState: string;
  contactId?: string;
  contactListeningData: ContactData;
}

export const ContactTimelineDisplay: React.FC<ContactTimelineDisplayProps> = ({
  contactListeningData,
}: ContactTimelineDisplayProps): React.ReactElement => {
  const intl = useIntl();
  const [isAnnotationsChecked, setAnnotationsChecked] = useState(true);
  const [isStateTransitionsChecked, setStateTransitionsChecked] =
    useState(false);

  const isAnnotationEvent = (item: ContactTimelineEvent) => {
    return (
      isAnnotationsChecked &&
      (item.eventType === EventType.AGENT_ANNOTATION ||
        item.eventType === EventType.AUTO_ANNOTATION)
    );
  };

  const isStateTransitionEvent = (item: ContactTimelineEvent) => {
    return (
      isStateTransitionsChecked && item.eventType === EventType.STATE_TRANSITION
    );
  };

  return (
    <Column>
      <div>
        {contactListeningData?.contact?.contactTimeline
          ?.contactTimelineEvents ? (
          <>
            <Row wrap={'down'}>
              <Checkbox
                checked={isAnnotationsChecked}
                onChange={setAnnotationsChecked}
              >
                <FormattedMessage
                  id='cs_perfportal_contact_timeline_annotations_checkbox'
                  defaultMessage='Annotations'
                />
              </Checkbox>
              <Checkbox
                checked={isStateTransitionsChecked}
                onChange={setStateTransitionsChecked}
              >
                <FormattedMessage
                  id='cs_perfportal_contact_timeline_state_transitions_checkbox'
                  defaultMessage='State Transitions'
                />
              </Checkbox>
            </Row>
            <Column width='100%' alignmentHorizontal='start'>
              <Text alignment='center' type='b300' color='secondary'>
                <FormattedMessage
                  id='cs_perfportal_contact_listening_timeline_ends'
                  defaultMessage='Timeline end'
                />
              </Text>
            </Column>
            <Timeline
              lineColor={MERIDIAN_COLORS.MERIDIAN_COLOR_BLUE_DARK}
              style={{ padding: '0px' }}
            >
              <div
                role='list'
                style={{
                  overflowX: 'hidden',
                  overflowY: 'auto',
                  padding: '1px',
                  wordWrap: 'break-word',
                }}
                className={`contact-timeline`}
              >
                {contactListeningData.contact.contactTimeline.contactTimelineEvents
                  .filter((item: ContactTimelineEvent) => {
                    return (
                      isStateTransitionEvent(item) || isAnnotationEvent(item)
                    );
                  })
                  .sort((a, b) => Date.parse(b.date) - Date.parse(a.date))
                  .map((item: ContactTimelineEvent) => (
                    <ContactTimelineEventBox contactTimelineEvent={item} />
                  ))}
              </div>
            </Timeline>
            <Column width='100%' alignmentHorizontal='start'>
              <Text alignment='center' type='b300' color='secondary'>
                <FormattedMessage
                  id='cs_perfportal_contact_listening_timeline_begins'
                  defaultMessage='Timeline start'
                />
              </Text>
            </Column>
          </>
        ) : (
          <Column alignmentHorizontal='center' alignmentVertical='center'>
            <div>
              <img
                src={CoachingEmptyState}
                alt='no contacts'
                style={{ maxWidth: '100%', maxHeight: '100%', height: 'auto' }}
              />
            </div>
            <Text>
              <FormattedMessage
                id='cs_perfportal_contact_timeline_no_events'
                defaultMessage='There is no contact timeline to display here at the moment.'
              />
            </Text>
          </Column>
        )}
      </div>
    </Column>
  );
};
export default ContactTimelineDisplay;
